/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Categories_AllInputs */

const en_admin_categories_all = /** @type {(inputs: Admin_Categories_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All Categories`)
};

const zh_admin_categories_all = /** @type {(inputs: Admin_Categories_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`所有分类`)
};

/**
* | output |
* | --- |
* | "All Categories" |
*
* @param {Admin_Categories_AllInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_categories_all = /** @type {((inputs?: Admin_Categories_AllInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Categories_AllInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_categories_all(inputs)
	return zh_admin_categories_all(inputs)
});
export { admin_categories_all as "admin.categories.all" }